.card {
    width: 100%;
    max-width: 753px;
    box-sizing: border-box;
    padding: 16px 16px 24px 16px;
    border: 1px solid #eceef2;
    border-radius: 16px;
    background-color: rgba(249, 250, 251, 0.5);
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.stepTitle {
    font-family: LustTextItalic, serif;
    font-style: italic;
    font-weight: 500;
    font-size: 14px;
    color: #101828;
    margin: 0;
}

.question {
    font-family: 'Hanken Grotesk', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5;
    color: #101828;
    margin: 0;
}

// Dashed divider is an SVG asset (icons/dashed-divider.svg) so we can honor the
// Figma spec exactly: dashes 1,4 with round caps (CSS border-style: dashed can't
// set dash length or cap shape). Container is the Figma 3px row with 1px top
// padding.
.divider {
    display: block;
    width: 100%;
    height: 2px;
    margin: 1px 0 0 0;
}

.actions {
    display: flex;
    align-items: center;
    justify-content: center;
}

// Spacer mirrors the timestamp column so the button group stays centered.
.actionsSpacer {
    flex: 1;
}

.buttonGroup {
    display: flex;
    align-items: center;
    gap: 12px;
}

.timestamp {
    flex: 1;
    text-align: right;
    font-family: 'Hanken Grotesk', sans-serif;
    font-weight: 400;
    font-size: 10px;
    line-height: 100%;
    color: #9198a6;
    white-space: nowrap;
}

.proceedButton {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 191px;
    height: 36px;
    padding: 0 8px;
    border: none;
    border-radius: 8px;
    background-color: #2075f4;
    color: #ffffff;
    font-family: 'Hanken Grotesk', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    box-shadow: 0px 2px 4px 0px rgba(4, 34, 80, 0.2);
    transition:
        background-color 0.15s ease,
        box-shadow 0.15s ease,
        filter 0.15s ease;

    // Gradient border overlay (top light → bottom dark), per Figma spec.
    &::after {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 8px;
        padding: 1px;
        background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.16) 0%,
            rgba(0, 0, 0, 0.16) 100%
        );
        -webkit-mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        pointer-events: none;
    }

    &:hover {
        background-color: #1a68e0;
        color: #ffffff;
    }

    &:active {
        background-color: #1659c4;
    }

    &:focus-visible {
        outline: none;
        box-shadow:
            0px 2px 4px 0px rgba(4, 34, 80, 0.2),
            0 0 0 3px rgba(32, 117, 244, 0.35);
    }

    &:disabled {
        cursor: not-allowed;
        filter: saturate(0.6) opacity(0.6);
    }
}

.feedbackButton {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 36px;
    padding: 0 14px;
    border: 1px solid #d0d5dd;
    border-radius: 8px;
    background-color: #ffffff;
    cursor: pointer;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    transition:
        background-color 0.15s ease,
        border-color 0.15s ease,
        box-shadow 0.15s ease;

    &:hover {
        background-color: #f9fafb;
        border-color: #b8c0cc;
    }

    &:active {
        background-color: #f2f4f7;
    }

    &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px rgba(32, 117, 244, 0.25);
    }

    &:disabled {
        cursor: not-allowed;
        filter: opacity(0.6);
    }
}

.feedbackLabel {
    color: #2075f4;
    white-space: nowrap;
    font-family: 'Hanken Grotesk', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 19.6px;
    letter-spacing: 0;
}

.checkIcon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    display: block;
}

.buttonLabel {
    color: #ffffff;
    white-space: nowrap;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
}

.spinner {
    width: 14px;
    height: 14px;
    border: 2px solid rgba(255, 255, 255, 0.5);
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: proceedSpin 0.7s linear infinite;
}

@keyframes proceedSpin {
    to {
        transform: rotate(360deg);
    }
}
